import {TextFieldProps} from '@mui/material';
import {DesktopDatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';

interface Props {
  label?: string;
  value?: Date | null;
  maxDate?: Date | null;
  disabled?: boolean;
  error?: boolean;
  renderInput?: Omit<TextFieldProps, 'variant'>;
  onChange?: (value: Date | null) => any;
}

export interface DateSelectHandle {
  open: () => void;
}

export const DateSelect = forwardRef<DateSelectHandle, Props>(
  ({label, value, maxDate, disabled, error, renderInput, onChange}, ref) => {
    const date = useMemo(() => (value ? dayjs(value) : null), [value]);
    const dateRef = useRef(date);
    const [tmpDate, setTmpDate] = useState(date);

    useEffect(() => {
      setTmpDate(date);
      dateRef.current = date;
    }, [date]);

    const [open, setOptn] = useState(false);

    useImperativeHandle(ref, () => ({
      open: () => setOptn(true),
    }));

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          open={open}
          value={tmpDate}
          label={label}
          disabled={disabled}
          format="YYYY-MM-DD"
          slotProps={{
            textField: {
              ...renderInput,
              inputProps: {
                readOnly: true,
              },
              onClick: () => setOptn(true),
            error,
            },
          }}
          maxDate={maxDate ? dayjs(maxDate) : null}
          sx={{input: {py: 1.1}}}
          onChange={(v) => {
            onChange?.(v?.toDate() ?? null);
            setTmpDate(v);
            setTimeout(() => {
              setTmpDate(dateRef.current);
            });
          }}
          onClose={() => setOptn(false)}
        />
      </LocalizationProvider>
    );
  }
);
